import React, { useRef, useState } from "react";
import {
  CustomDropDown,
  CustomIconField,
  CustomInput,
} from "shared/components/allInput";
import UploadIcon from "assets/icons/pinupload.svg";
import { Divider } from "primereact/divider";
import { useNavigate } from "react-router-dom";
import CustomButton, {
  Buttonlayout,
  CustomButtonOutlined,
  CustomFileuploadButton,
  OutlineRoundButton,
  RoundButton,
} from "shared/components/inputButton";
import Page from "shared/components/Page";
import CustomCard from "shared/components/CustomCard";
import CustomForm from "shared/components/CustomForm";
import CustomHeading from "shared/components/CustomHeading";
import CustomLabel from "shared/components/CustomLabel";
import LabelH4 from "shared/components/LabelH4";
import { YesNoOptions } from "shared/components/DropdownOptions";
import CustomForm2 from "shared/components/CustomForm2";
import CustomGrid from "shared/components/CustomGrid";
import CustomRow from "shared/components/CustomRow";
import ProjectContainer from "./ProjectContainer";
import {
  handleChange as arrayHandleChange,
  handleDelete,
} from "utils/TableFunctions";
import { FileUpload } from "primereact/fileupload";
import { useDispatch } from "react-redux";
import { projectType } from "shared/components/AllDropdownOptions";
export default function ProjectForms({ title }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    data,
    handleChange,
    writers,
    setWriters,
    addWriter,
    onSubmit,
    isProjectCreated,
    loading,
    onSaveDraft,
    draftLoading,
  } = ProjectContainer();

  const handleStartClearance = () => {
    navigate("/paper");
  };
  return (
    <Page title={title}>
      <Buttonlayout position="end">
        {(!data?.projectStatus || data?.projectStatus === "DRAFT") && (
          <OutlineRoundButton
            icon="pi pi-save"
            label="Save Draft"
            onClick={onSaveDraft}
            loading={draftLoading}
          />
        )}
        {isProjectCreated ? (
          <RoundButton
            label="Start Paperwork Clearance"
            onClick={handleStartClearance}
          />
        ) : (
          <RoundButton
            label={
              title === "Edit Project" ? "Update Project" : "Create Project"
            }
            onClick={onSubmit}
            loading={loading}
          />
        )}
      </Buttonlayout>
      <CustomForm2 title={"1. Basic Information"}>
        <p>
          Which party are you releasing your music with? Please choose either
          Label or Distributor.
        </p>
        <Buttonlayout className={"gap-3 my-3 "} position="left">
          {data?.releaseType === "label" ? (
            <CustomButton
              label="Label"
              onClick={() =>
                handleChange({ name: "releaseType", value: "label" })
              }
            />
          ) : (
            <CustomButtonOutlined
              label="Label"
              onClick={() =>
                handleChange({ name: "releaseType", value: "label" })
              }
            />
          )}
          {data?.releaseType === "distributor" ? (
            <CustomButton
              label="Distributor"
              onClick={() =>
                handleChange({ name: "releaseType", value: "distributor" })
              }
            />
          ) : (
            <CustomButtonOutlined
              label="Distributor"
              onClick={() =>
                handleChange({ name: "releaseType", value: "distributor" })
              }
            />
          )}
        </Buttonlayout>
        <p>Which label are you releasing with?</p>
        <CustomInput
          data={data}
          name="projectName"
          ignoreLabel
          onChange={handleChange}
        />
        <p>Is this a single or EP or an Album?</p>
        <CustomDropDown
          optionLabel="name"
          options={projectType}
          data={data}
          name="projectType"
          ignoreLabel
          onChange={handleChange}
        />
        <p>Do you have a recording or licensing agreement with the label? </p>
        <Buttonlayout className={"gap-3 my-3"} position="left">
          {data?.hasLicenseAgreement ? (
            <CustomButton
              label="Yes"
              onClick={() =>
                handleChange({ name: "hasLicenseAgreement", value: true })
              }
            />
          ) : (
            <CustomButtonOutlined
              label="Yes"
              onClick={() =>
                handleChange({ name: "hasLicenseAgreement", value: true })
              }
            />
          )}
          {data?.hasLicenseAgreement === false ? (
            <CustomButton
              label="No"
              onClick={() =>
                handleChange({ name: "hasLicenseAgreement", value: false })
              }
            />
          ) : (
            <CustomButtonOutlined
              label="No"
              onClick={() =>
                handleChange({ name: "hasLicenseAgreement", value: false })
              }
            />
          )}
        </Buttonlayout>
        <p className="py-3">
          Please upload a copy of the agreement for verification.
        </p>
        {(data?.licenseAgreementDocument?.name ||
          data?.licenseAgreementDocument) && (
          <p className="flex align-items-center gap-2 my-4">
            <img src={UploadIcon} alt="" />{" "}
            {data?.licenseAgreementDocument?.name ||
              data?.licenseAgreementDocument}
          </p>
        )}
        <CustomFileuploadButton
          name="licenseAgreementDocument"
          onChange={handleChange}
        />
      </CustomForm2>
      <Divider />
      <CustomForm2 title={"2. Paperwork Information"}>
        <p>
          Let’s get started to clear the paperwork for your single project{" "}
          <span className="color-verdigris font-bold">“Forestry”!</span>
        </p>
        <CustomGrid extraClassName={"my-2 align-items-center"}>
          <CustomRow title="Did you write the topline?">
            <CustomDropDown
              options={YesNoOptions}
              name="wroteTopline"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>

          {data?.wroteTopline === true && (
            <CustomRow title="Writers on the track:">
              <div className="grid mx-0">
                {writers?.map((item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <CustomIconField
                        data={item}
                        name="name"
                        col={6}
                        onChange={({ name, value }) =>
                          arrayHandleChange(
                            name,
                            value,
                            index,
                            writers,
                            setWriters
                          )
                        }
                        ignoreLabel
                        onClick={() => {
                          handleDelete(
                            writers,
                            setWriters,
                            index,
                            1,
                            dispatch,
                            "writer"
                          );
                        }}
                      />
                    </React.Fragment>
                  );
                })}
                <div className="col-6 my-1">
                  <CustomButton
                    icon="pi pi-plus"
                    label="Add"
                    extraClassName="mt-2"
                    onClick={addWriter}
                  />
                </div>
              </div>
            </CustomRow>
          )}
          <CustomRow title="Do you have a side artist on the project?">
            <CustomDropDown
              options={YesNoOptions}
              name="hasSideArtist"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
          <CustomRow title="Did you hire a producer?">
            <CustomDropDown
              options={YesNoOptions}
              name="hasProducer"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
          <CustomRow
            title="Did you hire a different producer (other than your producer in the
                            last question) for mixing and mastering?"
          >
            <CustomDropDown
              options={YesNoOptions}
              name="hasDifferentProducerForMixing"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
          <CustomRow title="Did you hire anyone to create your artwork?">
            <CustomDropDown
              options={YesNoOptions}
              name="artworkCreated"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
          <CustomRow title="Did you hire anyone to create your music video or visualiser?">
            <CustomDropDown
              options={YesNoOptions}
              name="musicVideoCreated"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
          <CustomRow title="Did you use any sample?">
            <CustomDropDown
              options={YesNoOptions}
              name="usedSample"
              data={data}
              onChange={handleChange}
              ignoreLabel
            />
          </CustomRow>
        </CustomGrid>
        {data?.usedSample === true && (
          <>
            <p className="py-2">
              Please upload a copy of the Sample Agreement.
            </p>
            <div
              className="flex align-items-center my-3 gap-3 bg-red-100 p-4"
              style={{ background: "rgba(244, 0, 0, 0.05)" }}
            >
              <i
                className="pi pi-info-circle text-red-500 text-2xl"
                style={{ color: "#F40000" }}
              ></i>
              <p className="text-red-500">
                We highly recommend any artist who uses a sample in their
                upcoming releases to book a consultation session to assess the
                likelihood of your track sample clearance before going further
                with your production and release plan.
              </p>
            </div>
            {/* {console.log("data", data?.sampleAgreementDocument)} */}
            {data?.sampleAgreementDocument?.name &&
              (data?.sampleAgreementDocument?.name ||
                data?.sampleAgreementDocument) && (
                <p className="flex align-items-center gap-2 my-4">
                  <img src={UploadIcon} alt="" />
                  {data?.sampleAgreementDocument?.name ||
                    data?.sampleAgreementDocument}
                </p>
              )}
            <CustomFileuploadButton
              name="sampleAgreementDocument"
              onChange={handleChange}
            />
          </>
        )}
      </CustomForm2>
      <Divider />
      <Buttonlayout position="start">
        {(!data?.projectStatus || data?.projectStatus === "DRAFT") && (
          <OutlineRoundButton
            icon="pi pi-save"
            label="Save Draft"
            onClick={onSaveDraft}
            loading={draftLoading}
          />
        )}
        {isProjectCreated ? (
          <RoundButton
            label="Start Paperwork Clearance"
            onClick={handleStartClearance}
          />
        ) : (
          <RoundButton
            label={
              title === "Edit Project" ? "Update Project" : "Create Project"
            }
            onClick={onSubmit}
            loading={loading}
          />
        )}
      </Buttonlayout>
    </Page>
  );
}
